module.exports = "https://static.cdns.space/tarot-temp/img/the-star.6faf0fe1.webp";